import '../index.css'
import * as React from 'react'
import { useContext } from 'react'
import { Button, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { isMobile } from 'react-device-detect'
import { PlusOutlined } from '@ant-design/icons'
import { InfoCxt } from '../../../App'
import { PaddingBox, PageSubtitle, PageTitle, TabHeader, TableBox } from '../../../components/Wrapper'

interface ResourcesDataType {
  id: string
  type: string
  source: string
  category: string
  subCategory: string
  image?: string
  title: string
  externalUrl: string
}

interface ResourcesProcessedDataType extends ResourcesDataType {
  markType: 'Assigned' | 'Saved'
}

const columns: ColumnsType<ResourcesProcessedDataType> = [
  { title: 'Type', dataIndex: 'type' },
  { title: 'Source', dataIndex: 'source' },
  { title: 'Title', dataIndex: 'title' },
  { title: 'Assigned / Saved', dataIndex: 'markType' },
  { title: 'Action', width: '116px', render: () => null },
]

/* -------------------------------- react fc -------------------------------- */

const Resource: React.FC = () => {
  const { showComingSoon } = useContext(InfoCxt)

  return (
    <>
      <TabHeader border>
        <PageTitle text='Resources' />
        <Button type='primary' ghost icon={<PlusOutlined />} onClick={showComingSoon}>
          {isMobile ? null : 'Add'}
        </Button>
      </TabHeader>
      <PaddingBox>
        <PageSubtitle text='Assigned Resources' />
        <TableBox>
          <Table columns={columns} dataSource={[]} rowKey={(record) => record.id} pagination={false} />
        </TableBox>
      </PaddingBox>
    </>
  )
}

export type { ResourcesProcessedDataType }
export default Resource
